'use client'
import React, {ReactNode, useContext, useEffect} from "react";
import {CustomNavigation} from "@/libs/contentful/fetch/content/navigation";
import NavListElement from "@/components/Layout/Header/Navigation/NavListElement";
import {
    MegaMenuProvider,
    MobileNavContext
} from "@/components/Layout/Header/Navigation/MainNavProvider";
import useWindowDimensions from "@/libs/contentful/helper/useWindowDimension";

interface Props {
    navigation: CustomNavigation
    children: ReactNode
}

export default function MainNavbar({navigation, children}: Props) {
    const {isMobileNavExpanded} = useContext(MobileNavContext);
    const { width } = useWindowDimensions();

    useEffect(()=> {
        navigation.elements.map((navItem) => {
            if(navItem.page.url.values === "https://www.bonprix.jobs/" || navItem.page.url.values === "https://www.bonprix.jobs/en/"){
                if(window.location.hostname == 'www.bonprix.it') {
                    navItem.page.url.values = "https://zinrec.intervieweb.it/bonprix/it/career"
                }
            }
        })
    },[navigation])

    return (
        <div
            className={"absolute left-[0] top-full h-[0] w-full overflow-auto brand-transition md:static md:block md:h-full md:max-h-[98px] md:w-5/6 md:overflow-visible bg-white" + (isMobileNavExpanded ? ' h-[calc(100dvh-90px)]' : ' invisible md:visible')}
            id="navbar-default"
        >
            <ul className="nav-list flex h-fit min-h-fill flex-initial flex-col bg-white md:h-full md:flex-row md:justify-end md:bg-transparent pl-[0] list-none my-[0]">
                {/*{width !== undefined && width < 834 && <li><SearchBar/></li>}*/}
                {Object.keys(navigation).length !== 0 && navigation.elements.map((navItem) => (
                    <MegaMenuProvider key={navItem.id}>
                        <NavListElement navItem={navItem}/>
                    </MegaMenuProvider>
                ))}
                {/*{width !== undefined && width > 833 && <li><SearchBar/></li>}*/}
                <MegaMenuProvider>
                    {children}
                </MegaMenuProvider>
            </ul>
        </div>
    )
}
